import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
} from "@/uiComponents/components/ui/dialog";
import { ImageProps } from "@/types/organization";
import { DialogTitle } from "@radix-ui/react-dialog";
import FilePreview from "@/reusable/FilePreview";

const ImageModal: React.FC<ImageProps> = ({ onClose, isOpen, expense }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);

  // Navigate to the previous file
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Navigate to the next file
  const handleNext = () => {
    if (expense.billPhotos && currentIndex < expense.billPhotos.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  // Toggle zoom state when image is clicked (only for images)
  const toggleZoom = () => {
    if (isPdf(currentIndex)) return; // Don't zoom for PDFs
    setIsZoomed(!isZoomed);
  };

  // Check if current file is a PDF
  const isPdf = (index: number) => {
    //@ts-expect-error:skip next line
    const file = expense.billPhotos?.[index]?.photo;
    return file?.includes(".pdf");
  };
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Bill Documents</DialogTitle>
        </DialogHeader>

        <div className="flex justify-center mb-4">
          {Array.isArray(expense.billPhotos) &&
          expense.billPhotos.length > 0 ? (
            <FilePreview
              //@ts-expect-error:skip next line
              src={expense.billPhotos[currentIndex].photo}
              name={`Bill Photo ${currentIndex + 1}`}
              isPdf={isPdf(currentIndex)}
              zoomed={isZoomed}
              onClick={toggleZoom}
              showName={false}
            />
          ) : (
            <p>No documents available</p>
          )}
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-between">
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className="px-4 py-2 cursor-pointer bg-blue-500 text-white rounded-lg disabled:opacity-50"
          >
            Previous
          </button>
          <span className="px-4 py-2">
            {currentIndex + 1} / {expense.billPhotos?.length || 0}
          </span>
          <button
            onClick={handleNext}
            disabled={currentIndex === (expense.billPhotos?.length || 0) - 1}
            className="px-4 py-2 cursor-pointer bg-blue-500 text-white rounded-lg disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImageModal;
